export default "__VITE_ASSET__DuDNOJcP__"